// Campus photo for /colleges/university-of-chicago: CC BY-SA 4.0, by Ndshankar, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Chicago_main_quadrangles.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-chicago/; credited under the photo.
const photo = {
    "slug": "university-of-chicago",
    "alt": "The Main Quadrangles at the University of Chicago in Hyde Park, Chicago, Illinois",
    "src": "/colleges/university-of-chicago/campus-1600.webp",
    "srcSmall": "/colleges/university-of-chicago/campus-800.webp",
    "srcMid": "/colleges/university-of-chicago/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-chicago/og.jpg",
    "title": "University of Chicago main quadrangles",
    "author": "Ndshankar",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Chicago_main_quadrangles.jpg",
    "read": "2026-10-01"
};

export default photo;
